module.exports = __webpack_public_path__ + "img/user-white.c4a600d3.svg";